import React, { useState, useEffect, useRef } from 'react';
import { Form, Row, Col, Card, Breadcrumb, Table } from 'react-bootstrap';
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import logoImage from '../../assets/images/logo.png';
import successVideo from '../../assets/video/paperplane.mp4';
import crossVideo from '../../assets/video/cross.mp4';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Paginator } from 'primereact/paginator';
import { Dialog } from 'primereact/dialog';
import Download_Letter from '../../modalPopup/Download_Letter';
import { Skeleton } from 'primereact/skeleton';
import { LiaSignatureSolid } from "react-icons/lia";
import { FileUpload } from 'primereact/fileupload';
import DatePicker from "react-datepicker";
import Edit_Send_Letter from './Edit_Send_Letter';


const Send_letter_list = () => {
    const [visible, setVisible] = useState(false);
    const { accessToken, userId } = useAuth();
    const [selectedLetter, setSelectedLetter] = useState(null); // State for selected letter
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const [isDialogVisible, setDialogVisible] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [uploadStatus, setUploadStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [dialogdateVisible, setDialogdateVisible] = useState(false);
    const [selectedLetterId, setSelectedLetterId] = useState(null);
    const [letterDate, setLetterDate] = useState(null);
    const [editVisible, setEditVisible] = useState(false);
    const [selectedEditLetter, setSelectedEditLetter] = useState(null); // State for selected letter to edit

    const fetchData = async () => {
        setLoading(true); // Set loading to true before fetching
        try {
            const response = await axios.get(`${config.apiBASEURL}/letterRoutes/fetch-send-letters`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            setData(response.data);
            setFilteredData(response.data);
        } catch (error) {
            console.error('Error fetching send letters:', error);
        } finally {
            setLoading(false); // Set loading to false after fetching
        }
    };
    useEffect(() => {
        fetchData();
    }, [accessToken]);


    // Function to delete a SendLetter
    const deleteLetter = async (id) => {
        setLoading(true); // Set loading to true before fetching
        try {
            await axios.delete(`${config.apiBASEURL}/letterRoutes/send-letter/${id}`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            setVideoDialogVisible(true); // Show video dialog

            setTimeout(() => {
                setVideoDialogVisible(false); // Hide video dialog after 5 seconds           
                fetchData();
            }, 5000);


        } catch (error) {
            console.error('Error deleting letter:', error);
            setVideocrossDialogVisible(true); // Show video dialog

            setTimeout(() => {
                setVideocrossDialogVisible(false); // Hide video dialog after 5 seconds           

            }, 5000);
        } finally {
            setLoading(false); // Set loading to false after fetching
        }
    };


    const openDialog = (letterId) => {
        setSelectedLetterId(letterId);
        setDialogdateVisible(true);
    };

    const sendLetter = async (letterId) => {
        if (!letterDate) {
            return;
        }
        setLoading(true); // Set loading to true before fetching
        // Convert letterDate to YYYY-MM-DD in local time
        const formattedDate = letterDate.toLocaleDateString('en-CA'); // 'yyyy-mm-dd'
        try {
            const response = await axios.post(
                `${config.apiBASEURL}/letterRoutes/sendletters/${selectedLetterId}/confirm`,
                { letter_date: formattedDate },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            // Show success message
            if (response.status === 200) {
                setDialogdateVisible(false);
                setSelectedLetterId(null);
                setLetterDate(null);
                setVideoDialogVisible(true); // Show video dialog

                setTimeout(() => {
                    setVideoDialogVisible(false); // Hide video dialog after 5 seconds
                    fetchData();
                }, 5000);
            }
        } catch (error) {
            // Handle errors and show an error message
            console.error('Error sending letter:', error);

            // Check if the error is due to an expired or invalid token
            if (error.response?.status === 401) {
                console.error('Unauthorized: Invalid or expired token.');
                // Optional: Add token refresh logic here if applicable
            }

            setVideocrossDialogVisible(true); // Show error dialog

            setTimeout(() => {
                setVideocrossDialogVisible(false); // Hide error dialog after 5 seconds
            }, 5000);
        } finally {
            setLoading(false); // Set loading to false after fetching
            setDialogdateVisible(false);
        }
    };

    const resendLetter = async (letterId) => {
        setLoading(true); // Set loading to true before fetching
        try {
            const response = await axios.post(
                `${config.apiBASEURL}/letterRoutes/resendletters/${letterId}/resend`,
                {}, // Empty body
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            // Show success message
            if (response.status === 200) {
                setVideoDialogVisible(true); // Show video dialog

                setTimeout(() => {
                    setVideoDialogVisible(false); // Hide video dialog after 5 seconds
                    fetchData();
                }, 5000);
            }
        } catch (error) {
            // Handle errors and show an error message
            console.error('Error resending letter:', error);

            // Check if the error is due to an expired or invalid token
            if (error.response?.status === 401) {
                console.error('Unauthorized: Invalid or expired token.');
                // Optional: Add token refresh logic here if applicable
            }

            setVideocrossDialogVisible(true); // Show error dialog

            setTimeout(() => {
                setVideocrossDialogVisible(false); // Hide error dialog after 5 seconds
            }, 5000);
        } finally {
            setLoading(false); // Set loading to false after fetching
        }
    };


    const onSearchChange = (e) => {
        setSearchQuery(e.target.value);
        filterData(e.target.value);
    };

    const filterData = (query) => {
        if (!query) {
            setFilteredData(data);
        } else {
            setFilteredData(
                data.filter((group) =>
                    group.employee_name.toLowerCase().includes(query.toLowerCase())
                )
            );
        }
    };


    const statusStyle = (status) => {
        switch (status) {
            case 'Generated':
                return { color: '#4caf50' };
            case 'Confirmed':
                return { color: '#ff9800' };
            case 'Edited':
                return { color: '#ff5722' };
            default:
                return { color: '#000' };
        }
    };

    const actionTemplate = (rowData) => {
        return (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
                {/* View/Download Button */}
                <Button
                    title="View/Download"
                    outlined
                    icon="pi pi-eye"
                    severity="primary"
                    className="p-button-sm border-0"
                    onClick={() => {
                        setSelectedLetter(rowData); // Set selected letter data
                        setVisible(true); // Show modal or component
                    }}
                />
                {rowData.status === "Generated" && (
                    <Button
                        title="Edit"
                        outlined
                        icon="pi pi-pencil"
                        severity="secondary"
                        className="p-button-sm border-0"
                        onClick={() => {
                            setSelectedEditLetter(rowData); // Set selected letter data
                            setEditVisible(true);           // Show modal or component
                        }}
                    />
                )}


                {/* Send Button */}
                {rowData.status === 'Confirmed' ? (
                    <Button
                        title="Resend"
                        outlined
                        icon="pi pi-refresh"
                        severity="warning"
                        className="p-button-sm border-0"
                        onClick={() => resendLetter(rowData.send_letter_id)}
                    />
                ) : (
                    <Button
                        title="Send"
                        outlined
                        icon="pi pi-send"
                        severity="success"
                        className="p-button-sm border-0"
                        onClick={() => openDialog(rowData.send_letter_id)}
                    />
                )}

                <Button
                    title="Download"
                    outlined
                    icon="pi pi-download"
                    severity="help"
                    className="p-button-sm border-0"
                    onClick={() => downloadPDF(rowData.send_letter_id)}
                />

                {/* Delete Button */}
                <Button
                    title="Delete"
                    outlined
                    icon="pi pi-trash"
                    severity="danger"
                    className="p-button-sm border-0"
                    onClick={() => {
                        deleteLetter(rowData.send_letter_id); // Delete the letter by ID
                    }}
                />
            </div>
        );
    };



    const handleFileSelect = (event) => {
        const file = event.files[0];
        setSelectedFile(file);
        setUploadStatus('');

        // Generate a preview URL for the selected file
        if (file) {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                setPreviewUrl(fileReader.result);
            };
            fileReader.readAsDataURL(file);
        } else {
            setPreviewUrl(null);
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            setUploadStatus('Please select a file before uploading.');
            return;
        }

        const formData = new FormData();
        formData.append('signature', selectedFile);
        formData.append('user_id', userId); // Dynamically use userId from auth

        try {
            const response = await axios.post(`${config.apiBASEURL}/letterRoutes/upload-signature`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${accessToken}`, // Add auth header
                },
            });
            if (response.status === 201) {
                setUploadStatus('Upload successful!');
                setSelectedFile(null);
                setPreviewUrl(null);

                // Close the dialog after 2 seconds
                setTimeout(() => {
                    setDialogVisible(false);
                    setUploadStatus(''); // Clear the upload status
                }, 2000);
            }

        } catch (error) {
            console.error('Upload error:', error);
            setUploadStatus('Upload failed. Please try again.');
        }
    };


    const downloadPDF = async (letterId) => {
        setLoading(true);

        try {
            const response = await axios.post(
                `${config.apiBASEURL}/letterRoutes/letters/${letterId}/pdf`,
                { user_id: userId },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data?.pdfUrl) {
                window.open(response.data.pdfUrl, "_blank"); // Open PDF in a new tab
            } else {
                console.error("PDF URL not found in response");
            }
        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {
            setLoading(false);
        }
    };










    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col sm={12} className="mb-4 d-flex justify-content-between align-items-center">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Send Letter List</Breadcrumb.Item>
                        </Breadcrumb>

                        <div>
                            <Button
                                label="Signatre"

                                icon={<LiaSignatureSolid />} // Use the desired icon
                                className="py-2 me-2"
                                severity="warning"
                                onClick={() => setDialogVisible(true)}
                            />
                            <Link to="/Graphe/dashboard/send_letter">
                                <Button
                                    label="Compose Letter"
                                    icon="pi pi-pencil"
                                    className="py-2"
                                    severity="help"
                                />
                            </Link>
                        </div>

                    </Col>
                    <Card>
                        <Card.Body>
                            {loading ? (
                                // Skeleton loader when loading
                                <div>
                                    <Skeleton width="100%" height="2rem" className="mb-2" />
                                    <Skeleton width="100%" height="2rem" className="mb-2" />
                                    <Skeleton width="100%" height="2rem" className="mb-2" />
                                    <Skeleton width="100%" height="2rem" className="mb-2" />
                                </div>
                            ) : (
                                <>
                                    <div className="d-flex justify-content-end">
                                        <InputText
                                            value={searchQuery}
                                            onChange={onSearchChange}
                                            placeholder="Search by employee name..."
                                            className="mb-3"
                                            style={{ width: '200px' }}
                                        />
                                    </div>
                                    <Accordion>
                                        {filteredData.slice(first, first + rows).map((group, index) => (
                                            <AccordionTab
                                                key={`${group.employee_name}-${index}`}
                                                header={
                                                    <div className="d-flex align-items-center">
                                                        <img
                                                            src={group.user?.profileImage?.image_url || logoImage}
                                                            alt={group.employee_name}
                                                            style={{
                                                                width: '36px',
                                                                height: '36px',
                                                                borderRadius: '50%',
                                                                marginRight: '10px',
                                                            }}
                                                        />
                                                        <span>{group.employee_name}</span>
                                                        <span className="ms-3 badge bg-info" style={{ fontSize: '0.8rem' }}>{group.user?.user_type}</span>
                                                        <span className="ms-3 badge bg-secondary" style={{ fontSize: '0.8rem' }}>{group.letters.length} Letters</span>
                                                    </div>
                                                }
                                            >
                                                <DataTable value={group.letters}>

                                                    <Column field="employee_name" header="Employee" />
                                                    <Column field="subject" header="Subject" />
                                                    <Column
                                                        field="status"
                                                        header="Status"
                                                        body={(rowData) => (
                                                            <span style={statusStyle(rowData.status)}>
                                                                {rowData.status}
                                                            </span>
                                                        )}
                                                    />
                                                    <Column
                                                        field="createdAt"
                                                        header="Creation Date"
                                                        body={(rowData) => {
                                                            const creationDate = new Date(rowData.createdAt);
                                                            return creationDate.toLocaleString("en-GB", {
                                                                day: "2-digit",
                                                                month: "short",   // "Sep" instead of "09"
                                                                year: "numeric",
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                second: "2-digit",
                                                                hour12: true,     // 12-hour clock with AM/PM
                                                            });
                                                        }}
                                                    />


                                                    <Column
                                                        header="Actions"
                                                        body={actionTemplate}
                                                        style={{ width: '150px' }}
                                                    />
                                                </DataTable>
                                            </AccordionTab>
                                        ))}
                                    </Accordion>
                                    <Paginator
                                        first={first}
                                        rows={rows}
                                        totalRecords={filteredData.length}
                                        onPageChange={(e) => {
                                            setFirst(e.first);
                                            setRows(e.rows);
                                        }}
                                    />
                                </>
                            )}
                        </Card.Body>
                    </Card>

                    <Dialog
                        visible={visible}
                        maximizable
                        style={{ width: '50vw' }}
                        onHide={() => {
                            if (!visible) return;
                            setVisible(false);
                        }}
                        className='letterDw_scroll'
                    >
                        <Download_Letter letter={selectedLetter} /> {/* Pass selected letter as a prop */}
                    </Dialog>


                    <Dialog
                        visible={editVisible}
                        maximizable
                        style={{ width: '90vw' }}
                        onHide={() => {
                            if (!editVisible) return;
                            setEditVisible(false);
                        }}
                        className='letterDw_scroll'
                    >
                        <Edit_Send_Letter letter={selectedEditLetter} onClose={() => {
                            setEditVisible(false);
                            fetchData();   // ✅ refresh after closing
                        }} /> {/* Pass selected letter as a prop */}
                    </Dialog>


                    <Dialog
                        header="Upload Signature"
                        visible={isDialogVisible}
                        style={{ width: '340px' }}
                        onHide={() => setDialogVisible(false)}
                        footer={
                            <div>
                                <Button
                                    label="Upload"
                                    icon="pi pi-upload"
                                    severity='success'
                                    className="me-2 py-2 border-0"
                                    onClick={handleUpload}
                                />
                                <Button
                                    label="Close"
                                    icon="pi pi-times"
                                    severity='danger'
                                    className=" py-2 border-0"
                                    onClick={() => setDialogVisible(false)}
                                />
                            </div>
                        }
                    >
                        <div>
                            <FileUpload
                                name="signature"
                                accept="image/*"
                                maxFileSize={1000000} // 1MB limit
                                onSelect={handleFileSelect}
                                mode="basic"
                                auto={false}
                                chooseLabel="Choose Image"

                            />
                            {previewUrl && (
                                <div style={{ marginTop: '20px' }}>
                                    <h6>Preview:</h6>
                                    <img
                                        src={previewUrl}
                                        alt="Signature Preview"
                                        style={{
                                            maxWidth: '100%',
                                            height: 'auto',
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                        }}
                                    />
                                </div>
                            )}
                            {uploadStatus && (
                                <p style={{ color: uploadStatus.includes('successful') ? 'green' : 'red' }}>
                                    {uploadStatus}
                                </p>
                            )}
                        </div>
                    </Dialog>

                    {/* <Dialog
                        header="PDF Options"
                        visible={ispdf}
                        onHide={() => setIspdf(false)}
                        style={{ width: '50vw' }}
                    >
                        <div>
                            <p>What would you like to do with the PDF?</p>
                            <Button label="Download PDF" icon="pi pi-download" onClick={handleDownload} />
                            <Button label="View PDF" icon="pi pi-search" onClick={handleView} style={{ marginLeft: '10px' }} />
                        </div>
                    </Dialog> */}


                    <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                        onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                        <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                        <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
                    </Dialog>


                    <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                        onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                        <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                        <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
                    </Dialog>

                    <Dialog
                        visible={dialogdateVisible}
                        style={{ width: '320px', zIndex: 1100 }} closable={false}
                        onHide={() => setDialogdateVisible(false)}
                        header="Select Letter Date"
                        footer={
                            <div>
                                <Button
                                    label="Cancel"
                                    icon="pi pi-times"
                                    className="py-2 border-0 me-2"
                                    severity='danger'
                                    onClick={() => setDialogdateVisible(false)}
                                />
                                <Button
                                    label="Send"
                                    icon="pi pi-check"
                                    className="py-2 border-0"
                                    severity='success'
                                    onClick={sendLetter}
                                    disabled={!letterDate}
                                    loading={loading}
                                />
                            </div>
                        }
                    >
                        <label>Select Letter Date:</label>
                        <DatePicker
                            selected={letterDate}
                            onChange={(date) => setLetterDate(date)}
                            dateFormat="dd/MM/yyyy"
                            className="form-control" // Bootstrap-styled input
                        />
                    </Dialog>

                </Row>
            </Row>

        </>
    );
};

export default Send_letter_list;
